module.exports = __webpack_public_path__ + "img/ResearchIcon2.bee6cfea.png";